import { Map, List, fromJS } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import axios from 'axios';

import { apiUrl } from 'libs/commonVar';

function getUserAPI(paramDatas) {
  return axios({
    method: 'get',
    url: apiUrl + 'User',
    params: {}
  });
}

function postUserAPI(paramDatas) {
  return axios({
    method: 'post',
    url: apiUrl + 'User',
    params: {
      userId: paramDatas.userId,
      userName: paramDatas.userName,
      userEmail: paramDatas.userEmail
    }
  });
}

function putUserAPI(paramDatas) {
  return axios({
    method: 'put',
    url: apiUrl + 'User',
    params: {
      userNo: paramDatas.userNo,
      userId: paramDatas.userId,
      userName: paramDatas.userName,
      userEmail: paramDatas.userEmail
    }
  });
}

function deleteUserAPI(paramDatas) {
  return axios({
    method: 'delete',
    url: apiUrl + 'User',
    params: {
      userNo: paramDatas.userNo
    }
  });
}

// action types
const INITIAL_STORE = 'userInfo/INITIAL_STORE';
const GET_USER = 'userInfo/GET_USER';
const POST_USER = 'userInfo/POST_USER';
const PUT_USER = 'userInfo/PUT_USER';
const DELETE_USER = 'userInfo/DELETE_USER';
const TOGGLE_EDITITEM = 'userInfo/TOGGLE_EDITITEM';

// action creator
export const initialStore = createAction(INITIAL_STORE);
export const getUser = createAction(GET_USER, getUserAPI);
export const postUser = createAction(POST_USER, postUserAPI);
export const putUser = createAction(PUT_USER, putUserAPI);
export const deleteUser = createAction(DELETE_USER, deleteUserAPI);
export const toggleEditItem = createAction(TOGGLE_EDITITEM);

const initialState = List([
  Map({
    isEdit: false,
    userNo: 0,
    userId: '',
    userName: '',
    userEmail: ''
  })
]);

export default handleActions(
  {
    // store 초기화
    [INITIAL_STORE]: (state, action) => {
      return initialState;
    },
    ...pender({
      type: GET_USER, // type 이 주어지면, 이 type 에 접미사를 붙인 액션핸들러들이 담긴 객체를 생성합니다.
      /*
          요청중 / 실패 했을 때 추가적으로 해야 할 작업이 있다면 이렇게 onPending 과 onFailure 를 추가해주면됩니다.
          onPending: (state, action) => state,
          onFailure: (state, action) => state
      */
      onSuccess: (state, action) => {
        // 성공했을때 해야 할 작업이 따로 없으면 이 함수 또한 생략해도 됩니다.
        const { list } = action.payload.data;
        return fromJS(list);
      }
      // 함수가 생략됐을때 기본 값으론 (state, action) => state 가 설정됩니다 (state 를 그대로 반환한다는 것이죠)
    }),
    ...pender({
      type: POST_USER,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;

        return state.push(fromJS(list));
      }
    }),
    ...pender({
      type: PUT_USER,
      onSuccess: (state, action) => {
        let userData = action.payload.data.list[0];
        const index = state.findIndex(userInfo => userInfo.get('userNo') === userData.userNo);

        userData = {
          ...userData,
          isEdit: false
        };

        return state.mergeIn([index], fromJS(userData));
      }
    }),
    ...pender({
      type: DELETE_USER,
      onSuccess: (state, action) => {
        const userNo = action.payload.data.list[0].userNo;
        const index = state.findIndex(userInfo => userInfo.get('userNo') === userNo);

        return state.delete(index);
      }
    }),
    [TOGGLE_EDITITEM]: (state, action) => {
      const index = state.findIndex(userInfo => userInfo.get('userNo') === action.payload);

      return state.update(index, userInfo => userInfo.set('isEdit', !userInfo.get('isEdit')));
    }
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/script/modules/userInfo.js